import axios from 'axios'
import { endpoints } from '../config'
import { getApiClient, postApiClient, putApiClient } from './api-client'
import authSignerData from './mockdata/mockdata-auth-signer.json'
import pricingData from './mockdata/mockdata-pricing.json'
import eventData from './mockdata/mockdata.json'
import { SwapOptionObject } from '../app/tickets/components/swap-event-menu'
import dayjs from 'dayjs'
import { getBrowserCurrentTime } from '../utils'

export async function getMockEventsData() {
  return eventData
}
export async function getEvents({
  date = '',
  eventName = '',
  venueName = '',
  eventStatus = '',
  page = 1,
  pageSize = 15,
} = {}) {
  const params = {
    page,
    pageSize,
    date,
    eventName,
    venueName,
    eventStatus,
    eventId: '',
    browserCurrentTime: getBrowserCurrentTime(),
  }
  return getApiClient({ endpoint: endpoints.getEvents, params })
}

// export async function getAllEvents({
//   date = '',
//   eventName = '',
//   venueName = '',
//   eventStatus = '',
//   page = 1,
//   pageSize = 15,
// } = {}) {
//   const params = {
//     pageObject: JSON.stringify({
//       skip: '0',
//       take: pageSize,
//       page,
//       pageSize,
//     }),
//     date,
//     eventName,
//     venueName,
//     eventStatus,
//     eventId: '',
//   }
//   return getApiClient({ endpoint: endpoints.getEvents, params })
// }

export async function getEventSearch({
  searchInput,
  yearFilter,
}: {
  searchInput: string | ''
  yearFilter?: boolean
}) {
  // const noSpecialCharsRegex = /^\w+$/
  const params = {
    search: searchInput || '',
    searchDate: '',
    yearFilter,
  }

  return getApiClient({ endpoint: endpoints.search, params })
}

export async function getEventDetail({ eventId, employeeId }: { eventId: string; employeeId: string }) {
  const params = {
    eventId,
    employeeId,
  }
  return getApiClient({ endpoint: endpoints.getEventDetail, params })
}

export interface EventLockStatusPayload {
  eventid: string
}

export interface EventLockStatusResponse {
  EventLockedDetail: {
    EventId: string
    EventLocked: number
    EventLockedBy: string | null
  }
}

export async function getEventLockStatus(
  params: EventLockStatusPayload
): Promise<EventLockStatusResponse> {
  return getApiClient({ endpoint: endpoints.getEventLockStatus, params })
}

export interface UpdateEventLockStatusPayload {
  eventid: string
  eventlocked: 0 | 1
  eventlockedby: string
  eventlockedbyid: string
}

export interface UpdateEventLockStatusResponse {
  totalUpdated: number
}

export async function updateEventLockStatus(
  params: UpdateEventLockStatusPayload
): Promise<UpdateEventLockStatusResponse> {
  return putApiClient({ endpoint: endpoints.updateEventLockStatus, params })
}

export async function readSwapEvents({
  eventName,
  page,
  pageSize,
}: {
  eventName: string
  page?: string
  pageSize?: string
}): Promise<SwapOptionObject> {
  const params = {
    eventName,
    browserCurrentTime: getBrowserCurrentTime(),
    page,
    pageSize,
  }
  return getApiClient({ endpoint: endpoints.readSwapEvents, params })
}

export async function getMockPricingData() {
  return pricingData
}

export async function getMockSignerData() {
  return authSignerData
}

export async function submitEventTicketRequest(payload: any, navigatedFrom: string) {
  const params = { navigatedFrom }
  return postApiClient({ endpoint: endpoints.submitTicketRequest, payload, params })
}
